import { render, staticRenderFns } from "./bindBank.vue?vue&type=template&id=a621ff02&scoped=true&"
import script from "./bindBank.vue?vue&type=script&lang=js&"
export * from "./bindBank.vue?vue&type=script&lang=js&"
import style0 from "./bindBank.vue?vue&type=style&index=0&id=a621ff02&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a621ff02",
  null
  
)

export default component.exports